import React from 'react';
import styled from 'styled-components';
import {AccentColorOptions, AccentColorProps} from 'epic-ue-theme';

const getRadialGradient = (from, to) =>
    `radial-gradient(100% 185.14% at 100% 100%, ${from} 0%, ${to} 100%)`;

const FeaturesIconLine = styled.div<{accentColor: AccentColorOptions}>`
    height: 2px;
    background: ${(p) =>
        getRadialGradient(
            p.theme.palette.gradient[p.accentColor].from,
            p.theme.palette.gradient[p.accentColor].to
        )};
`;
export const FeaturesLineIcon = ({accentColor = 'sky'}: AccentColorProps): JSX.Element => {
    return <FeaturesIconLine accentColor={accentColor} />;
};
